export default __webpack_public_path__ + "static/media/img-2.2f0d2ede.jpg";